import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const ReportParameterSummaryComponent = ({ reportParameter }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportParameters.ParamName')} : <span> {reportParameter.paramName} </span>
      </Grid>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportParameters.FilterCode')} : <span> {reportParameter.filterCode} </span>
      </Grid>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportParameters.FilterMember')} : <span> {reportParameter.filterMember} </span>
      </Grid>
    </Grid>
  );
};

ReportParameterSummaryComponent.propTypes = {
  reportParameter: PropTypes.object.isRequired
};

export default ReportParameterSummaryComponent;
